import { render } from "./Certificates.vue?vue&type=template&id=7adf2a06&scoped=true"
import script from "./Certificates.vue?vue&type=script&lang=js"
export * from "./Certificates.vue?vue&type=script&lang=js"

import "./Certificates.vue?vue&type=style&index=0&id=7adf2a06&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7adf2a06"]])

export default __exports__